import React from 'react';
import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { getChainReleaseOptions } from '../../../helpers/chainRelease';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Caption } from '../../Common/Caption';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  chainRelease: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (chainRelease, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      chainRelease,
    },
  });

export const ChainRelease = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { chainRelease },
  } = state.context;

  const chainReleaseOptions = getChainReleaseOptions(state.context);

  if (
    isCurrentState('chainRelease', state) &&
    chainReleaseOptions.length === 0
  ) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Chain Release</Heading>
      <Caption>Chain Release</Caption>
      <Selector>
        {chainReleaseOptions.map(option => {
          return (
            <SelectorItem
              isSelected={option === chainRelease}
              onClick={onClick(option, send)}
              key={option}
            >
              {option}
            </SelectorItem>
          );
        })}
      </Selector>
    </SectionContent>
  );
};
